<template>
  <page-header-wrapper>
    <a-alert
      v-if="!merchantId"
      type="warning"
      show-icon
      :message="$t('请从商家列表进入佣金设置')"
      style="margin-bottom: 16px"
    />
    <commission-settings v-if="merchantId" :key="merchantId" :merchant-id="merchantId"></commission-settings>
  </page-header-wrapper>
</template>
<script>
import CommissionSettings from "@/views/agent/components/commissionSetting";
export default {
  name: "Agent",
  components: {CommissionSettings},
  computed: {
    merchantId() {
      return this.$route.query.merchantId
    }
  }
}
</script>
<style scoped lang="less">

</style>